export default {
    namespaced: true,
    state: {
        istDatenUebernahmeMUK: false,
        unternehmensbezeichnung: null,
        zusatzUnternehmensbezeichnung: null,
        land: 'DE',
        strasse: null,
        hausNrUndzusatz: null,
        postleitzahl: null,
        ort: null,
        adresszusatz: null,
        istPostfachPost: false,
        postfach: null,
        postfachPLZ: null,
        postfachOrt: null,
        freitext: null,
        cofreitext: null,
        freitextAusland: null
    },
    getters: {
        istDatenUebernahmeMUK (state) {
            return state.istDatenUebernahmeMUK
        },
        unternehmensbezeichnung (state) {
            return state.unternehmensbezeichnung
        },
        zusatzUnternehmensbezeichnung (state) {
            return state.zusatzUnternehmensbezeichnung
        },
        land (state) {
            return state.land
        },
        strasse (state) {
            return state.strasse
        },
        hausNrUndzusatz (state) {
            return state.hausNrUndzusatz
        },
        postleitzahl (state) {
            return state.postleitzahl
        },
        ort (state) {
            return state.ort
        },
        adresszusatz (state) {
            return state.adresszusatz
        },
        istPostfachPost (state) {
            return state.istPostfachPost
        },
        postfach (state) {
            return state.postfach
        },
        postfachPLZ (state) {
            return state.postfachPLZ
        },
        postfachOrt (state) {
            return state.postfachOrt
        },
        freitext (state) {
            return state.freitext
        },
        cofreitext (state) {
            return state.cofreitext
        },
        freitextAusland (state) {
            return state.freitextAusland
        }
    },
    mutations: {
        istDatenUebernahmeMUK (state, istDatenUebernahmeMUK) {
            state.istDatenUebernahmeMUK = istDatenUebernahmeMUK
        },
        unternehmensbezeichnung (state, unternehmensbezeichnung) {
            state.unternehmensbezeichnung = unternehmensbezeichnung
        },
        zusatzUnternehmensbezeichnung (state, zusatzUnternehmensbezeichnung) {
            state.zusatzUnternehmensbezeichnung = zusatzUnternehmensbezeichnung
        },
        strasse (state, strasse) {
            state.strasse = strasse
        },
        land (state, land) {
            state.land = land
        },
        hausNrUndzusatz (state, hausNrUndzusatz) {
            state.hausNrUndzusatz = hausNrUndzusatz
        },
        postleitzahl (state, postleitzahl) {
            state.postleitzahl = postleitzahl
        },
        ort (state, ort) {
            state.ort = ort
        },
        adresszusatz (state, adresszusatz) {
            state.adresszusatz = adresszusatz
        },
        istPostfachPost (state, istPostfachPost) {
            state.istPostfachPost = istPostfachPost
        },
        postfach (state, postfach) {
            state.postfach = postfach
        },
        postfachPLZ (state, postfachPLZ) {
            state.postfachPLZ = postfachPLZ
        },
        postfachOrt (state, postfachOrt) {
            state.postfachOrt = postfachOrt
        },
        freitext (state, freitext) {
            state.freitext = freitext
        },
        cofreitext (state, cofreitext) {
            state.cofreitext = cofreitext
        },
        freitextAusland (state, freitextAusland) {
            state.freitextAusland = freitextAusland
        },
        reset(state) {
            state.istDatenUebernahmeMUK = false
            state.unternehmensbezeichnung = null
            state.zusatzUnternehmensbezeichnung = null
            state.land = 'DE'
            state.strasse = null
            state.hausNrUndzusatz = null
            state.postleitzahl = null
            state.ort = null
            state.adresszusatz = null
            state.istPostfachPost = false
            state.postfach = null
            state.postleitzahl = null
            state.postfachOrt = null
            state.freitext = null
            state.cofreitext = null
            state.freitextAusland = null
        }
    },
    actions: {

    }
}
